type RoomTypeAdjustmentFactor = {
  factorType: string
  selectedId?: string | null
  options?: Array<{
    id: string
    optionLabel?: string
    limitValue?: string | number | null
    isDefault?: boolean
  }>
}

type RoomTypeOptionalBenefit = {
  benefitType: string
  selectedId?: string | null
  options?: Array<{
    id: string
    optionLabel?: string
    limitValue?: string | number | null
    copayPct?: number | null
    isDefault?: boolean
  }>
}

function pickSelectedOption<
  T extends { id: string; isDefault?: boolean },
>(options: T[] | undefined, selectedId: string | null | undefined): T | undefined {
  if (!options?.length) return undefined
  return (
    (selectedId ? options.find((o) => o.id === selectedId) : undefined) ??
    options.find((o) => o.isDefault) ??
    options[0]
  )
}

/** Selected room-type label from adjustment / optional-benefit selections. */
export function resolveSelectedRoomTypeLabel(input: {
  adjustmentFactors?: RoomTypeAdjustmentFactor[] | null
  optionalBenefits?: RoomTypeOptionalBenefit[] | null
}): string | null {
  const roomFactor = input.adjustmentFactors?.find(
    (f) => f.factorType === "room_type"
  )
  if (roomFactor) {
    const selected = pickSelectedOption(
      roomFactor.options,
      roomFactor.selectedId
    )
    const label = selected?.optionLabel?.replace(/%/g, "").trim()
    if (label) return label
    const limit = selected?.limitValue
    if (limit != null && String(limit).trim()) return String(limit).trim()
  }

  const roomBenefit = input.optionalBenefits?.find(
    (b) => b.benefitType === "room_type"
  )
  if (roomBenefit) {
    const selected = pickSelectedOption(
      roomBenefit.options,
      roomBenefit.selectedId
    )
    const label = selected?.optionLabel?.replace(/%/g, "").trim()
    if (label) return label
    const limit = selected?.limitValue
    if (limit != null && String(limit).trim()) return String(limit).trim()
    if (selected?.copayPct != null) return `${selected.copayPct}%`
  }

  return null
}
